<template>
  <div>
    <b-container>
      <div class="header-body text-center mb-8">
        <b-row class="justify-content-center">
          <b-col xl="5" lg="6" md="8" class="px-5 py-5">
            <h1 class="text-white bebas-header">Lo sentimos, pero tu pago fue rechazado</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="text-lead text-white mt-0 mb-0">Inténtalo nuevamente, o usa otro medio de pago:</p>

            <base-button type="secondary" native-type="submit" class="mt-5" @click="goToCheckout">
              <span>Ir al pago</span>
            </base-button> 
          </b-col>
        </b-row>
      </div>
    </b-container>
    <!-- <div class="separator separator-bottom separator-skew zindex-100">
      <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
            xmlns="http://www.w3.org/2000/svg">
        <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div> -->
  </div>

</template>

<script>
export default {
  methods: {
    goToCheckout() {
      this.$router.push({ name: 'Checkout' })
    }
  }
}
</script>

<style>

</style>